import MiniGetAQuote from "./mini-get-a-quote/MiniGetAQuote";

export default function App() {
  return <MiniGetAQuote />;
}
